import { useTranslation } from 'react-i18next';

import Typography, { TAG, VARIANT } from '~/components/isolated/Typography';
import CDPrice from '~/components/Price/CDPrice/CDPrice';

import styles from './OrderTotal.module.scss';

interface OrderTotalProps {
  amount: string;
}

/**
 * OrderTotal component
 * Displays the final subtotal amount
 */
const OrderTotal = ({ amount }: OrderTotalProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography variant={VARIANT['Header 100/Medium']} as={TAG.h3}>
        {t('subtotal')}
      </Typography>
      <CDPrice
        price={amount}
        classes={{ classNameCurrentPrice: styles.amount }}
      />
    </div>
  );
};

export default OrderTotal;
